export default __webpack_public_path__ + "static/media/Digital_Display.f6dd6680.ttf";